@if (title) {
<h6
  [attr.data-e2e]="'title-text-' + title"
  class="title text-truncate font-size-lg px-2"
>
  {{ title }}
</h6>
}
